/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchSorting = {
    Name: 'Name',
    Date: 'Date',
    Amount: 'Amount'
} as const;
export type SearchSorting = typeof SearchSorting[keyof typeof SearchSorting];


export function instanceOfSearchSorting(value: any): boolean {
    for (const key in SearchSorting) {
        if (Object.prototype.hasOwnProperty.call(SearchSorting, key)) {
            if (SearchSorting[key as keyof typeof SearchSorting] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchSortingFromJSON(json: any): SearchSorting {
    return SearchSortingFromJSONTyped(json, false);
}

export function SearchSortingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSorting {
    return json as SearchSorting;
}

export function SearchSortingToJSON(value?: SearchSorting | null): any {
    return value as any;
}

export function SearchSortingToJSONTyped(value: any, ignoreDiscriminator: boolean): SearchSorting {
    return value as SearchSorting;
}

